import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign } from '@feathr/blackbox';
import { CampaignState } from '@feathr/blackbox';
import { ConfirmModal, toast } from '@feathr/components';
import CampaignSummary from '@feathr/extender/App/EventsPage/CampaignSummary';

interface ICampaignStopModalProps {
  campaign: Campaign;
  opened: boolean;
  close: () => void;
}

function CampaignStopModal({
  campaign,
  opened,
  close,
}: Readonly<ICampaignStopModalProps>): JSX.Element {
  const { t } = useTranslation();

  async function handleStop(): Promise<void> {
    try {
      campaign.set({
        is_enabled: false,
        is_archived: false,
        state: CampaignState.Stopped,
      });
      await campaign.save();
      toast(t('Campaign stopped. You can republish it anytime.'));

      close();
    } catch (error: any) {
      toast(
        t("We couldn't stop the campaign. {{- errorMessage}} Try again or contact support.", {
          errorMessage: error.message,
        }),
        {
          type: 'error',
        },
      );
    }
  }

  return (
    <ConfirmModal
      confirmationPhrase={t('STOP')}
      confirmButtonText={t('Stop')}
      confirmButtonType={'danger'}
      description={t(
        'This will pause ad delivery immediately. You can republish the campaign later.',
      )}
      onClose={close}
      onConfirm={handleStop}
      opened={opened}
      t={t}
      title={t('Stop this campaign?')}
    >
      <CampaignSummary campaign={campaign} layout={'vertical'} showMinimal={true} />
    </ConfirmModal>
  );
}

export default CampaignStopModal;
